module.exports = __webpack_public_path__ + "fonts/605ee8e5d7b1567775c53aca3285e525.svg";